/**
 * 「上次见到时已登录」的本地提示。营销页是静态预渲染，服务端不知道登录态，
 * session 要等前端请求回来；Document 里的内联脚本在首帧前读这个标记给 <html>
 * 打 data-authed，只对登录用户藏的东西（hero 的免费积分那行）就能直接用 CSS
 * `[[data-authed]_&]:hidden` 藏掉，不用等请求回来再让下面的生成器往上跳（CLS）。
 * 标记偶尔会过期（别处退出、session 到期），SessionProvider 拿到真实登录态后纠正。
 */
const AUTH_HINT_KEY = "ia-authed";

export const AUTH_HINT_SCRIPT = `try{localStorage.getItem("${AUTH_HINT_KEY}")&&document.documentElement.setAttribute("data-authed","")}catch(e){}`;

export function setAuthHint(authed: boolean) {
	try {
		if (authed) {
			localStorage.setItem(AUTH_HINT_KEY, "1");
		} else {
			localStorage.removeItem(AUTH_HINT_KEY);
		}
	} catch {
		// 隐私模式等拿不到 localStorage：只是少一次首帧预判，属性照常切
	}
	document.documentElement.toggleAttribute("data-authed", authed);
}
